import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { ModalComponent } from "src/app/shared/modal/modal.component";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {

  @ViewChild('modal') modal!: ModalComponent;
  collapseShow = "hidden";
  constructor(private oidcSecurityService: OidcSecurityService,
              private router: Router
  ) {}

  ngOnInit() {}
  toggleCollapseShow(classes) {
    this.collapseShow = classes;
  }

  logout() {
    this.oidcSecurityService.logoff().subscribe((res: any) => {
      console.log(res);

      this.router.navigate(['/']);
      
    })
  }

  openModal() {
    this.modal.open();
  }

  closeModal() {
    this.modal.close();
  }

}
